import { sortByKey } from 'utils/sortByKey'

export const filterUniqueAndMapToValueAndLabel = <T>(args: {
  items: Array<T>
  filter?: (item: T) => boolean
  uniqueBy: (item: T) => string
  mapToLabel: (item: T) => string
}) => {
  return Object.entries(
    args.items.reduce<Record<string, string>>((acc, item) => {
      const k = args.uniqueBy(item)
      const filterCheck = args.filter ? args.filter(item) : true

      if (filterCheck && !acc[k]) {
        return { ...acc, [k]: args.mapToLabel(item) }
      } else {
        return acc
      }
    }, {}),
  )
    .map(([k, v]) => ({ label: v, value: k, id: k }))
    .sort(sortByKey('label'))
}
